var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBikeAndScooterRental = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Bike-Public-Service-3--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Bike Public Service 3 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.34 0h-7.06a2.67 2.67 0 0 0 -2.66 2.7v7.82a2.13 2.13 0 0 1 0.83 -0.18h2.25a2 2 0 0 1 0.31 4l0.05 0.23A5.33 5.33 0 0 1 17.73 24h5.52a0.76 0.76 0 0 0 0.75 -0.75V2.7A2.66 2.66 0 0 0 21.34 0Zm-3 8.79v0.44a0.5 0.5 0 0 1 -0.5 0.5 0.5 0.5 0 0 1 -0.5 -0.5v-0.4a1.78 1.78 0 0 1 -0.79 -0.47 0.5 0.5 0 1 1 0.71 -0.7 0.81 0.81 0 0 0 0.58 0.25 0.81 0.81 0 0 0 0 -1.61 1.79 1.79 0 0 1 -0.5 -3.52v-0.45a0.5 0.5 0 0 1 0.5 -0.5 0.51 0.51 0 0 1 0.5 0.5v0.46a1.62 1.62 0 0 1 0.63 0.31 0.5 0.5 0 0 1 0.08 0.7 0.51 0.51 0 0 1 -0.71 0.08 0.75 0.75 0 0 0 -0.5 -0.18 0.8 0.8 0 0 0 0 1.6 1.8 1.8 0 0 1 0.5 3.53Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.42 15.28 0.2 0.81a4.11 4.11 0 1 0 1.71 -0.38 1.9 1.9 0 0 0 -0.25 0l-0.67 -2.65h1.29a0.75 0.75 0 0 0 0 -1.5h-2.25a0.72 0.72 0 0 0 -0.59 0.29 0.74 0.74 0 0 0 -0.13 0.64l0.32 1.31 -1.22 0.25 -2.76 0.58 -0.42 -1.2h0.91a0.75 0.75 0 1 0 0 -1.5h-2a0.76 0.76 0 0 0 -0.71 1l0.84 2.43 -0.66 0.83a4.16 4.16 0 0 0 -1.95 -0.51 4.17 4.17 0 1 0 3.12 1.45l0.8 -0.92 3.11 -0.65Zm1.91 7.18A2.62 2.62 0 0 1 13 17.59l0.6 2.41a0.75 0.75 0 0 0 0.73 0.57 0.57 0.57 0 0 0 0.18 0 0.74 0.74 0 0 0 0.54 -0.91l-0.6 -2.43a2.62 2.62 0 0 1 -0.12 5.24Zm-7.58 -2.62a2.63 2.63 0 1 1 -2.63 -2.63 2.5 2.5 0 0 1 1 0.2l-1.57 2a0.75 0.75 0 0 0 0.11 1.05 0.75 0.75 0 0 0 1.06 -0.11l1.57 -2a2.61 2.61 0 0 1 0.46 1.49Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBikeAndScooterRental);
export default ForwardRef;